import React from "react";
import "./index.scss";

interface StatSummaryProps {
  circuit: string;
  number: string;
  summary: string;
  image: string;
  logo: string;
  alignment: string;
}

const StatSummary = ({
  circuit,
  number,
  summary,
  image,
  logo,
  alignment
}: StatSummaryProps) => {
  return (
    <section>
      <div className="container">
        <div className={`statSummary ${alignment}`}>
          <div className="statSummary__details">
            <div className={`statSummary__number ${circuit}`}>{number}</div>
            <div className="statSummary__description">{summary}</div>
          </div>
          <div className="statSummary__thumb">
            {image.length > 0 ? (
              <img src={image} alt="" className="statSummary__image" />
            ) : null}
            {logo.length > 0 ? (
              <img src={logo} alt="" className="statSummary__logo " />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatSummary;
